import { post } from "./request";

/**
 * 认证相关接口（API 文档第 1 节 /console/auth）。
 */

/** 登录 / 验证注册成功后的返回 */
export interface AuthResult {
  token: string;
  userId: number;
  email: string;
  onboardingCompleted: boolean;
}

export interface MessageResult {
  message: string;
  email?: string;
}

/** POST /auth/register — 注册第一步：发送邮箱验证码 */
export function register(
  email: string,
  password: string
): Promise<MessageResult> {
  return post<MessageResult>("/auth/register", { email, password });
}

/** POST /auth/verify-email — 注册第二步：验证码确认并创建账户 */
export function verifyEmail(
  email: string,
  code: string,
  password: string
): Promise<AuthResult> {
  return post<AuthResult>("/auth/verify-email", { email, code, password });
}

/** POST /auth/login */
export function login(
  email: string,
  password: string,
  rememberMe: boolean
): Promise<AuthResult> {
  return post<AuthResult>("/auth/login", { email, password, rememberMe });
}

/** POST /auth/resend-code */
export function resendCode(email: string): Promise<MessageResult> {
  return post<MessageResult>("/auth/resend-code", { email });
}

/** POST /auth/forgot-password — 无论邮箱是否存在都返回相同响应 */
export function forgotPassword(email: string): Promise<MessageResult> {
  return post<MessageResult>("/auth/forgot-password", { email });
}

/** POST /auth/reset-password — 用 URL 里的 token + 新密码重置 */
export function resetPassword(
  token: string,
  newPassword: string
): Promise<MessageResult> {
  return post<MessageResult>("/auth/reset-password", { token, newPassword });
}
